export const initials = (name: string): string => {
  const initials: any = name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g)

  return initials.join('')
}
